import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle, withState } from "recompose";
import { withRouter } from "react-router-dom";
import { find, forEach } from "lodash";

import Header from "../components/HostServerOrgHeader";
import Info from "../components/organization/Info";
import UsersAndPackages from "../components/organization/UsersAndPackages";
import Button from "react-md/lib/Buttons/Button";


import {DebugElementBegin, DebugElementEnd, DebugElement} from "../Atollon/debug";

import {
  setActiveHost,
  setActiveServer,
  setActiveOrganization
} from "../actions/activeActions";
import { setDialog } from "../actions/dialogActions";
import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";
import Buttons from "../components/Buttons";

/**
 *
 * @param match
 * @param location
 * @param history ... from React prop
 * @param host ... from React prop
 * @param server .... from React prop
 * @returns {*}
 * @constructor
 */
const Organization = ({
  match,
  history,
  host,
  server
}) => {
  const organization = server
    ? find(server.organizations, o => o.id === match.params.id)
    : null;

    if (organization) {
    return (
      <div className="flex-col">

          <DebugElementBegin text="containers/Organization.js"/>

          <TouchPageHeader
              title={(

                  <span>
                      <span
                          className="link"
                          onClick={() => history.push(`/hosts/${host.id}`)}
                      >
                        {host.name}
                      </span>
                      {" > "}
                      <span
                          className="link"
                          onClick={() => history.push(`/hosts/${host.id}/${server.id}`)}
                      >
                        {server.name}
                      </span>
                      {" > "}
                      {organization.name}
                    </span>
              )}
              buttons={(
                  <Button
                      raised
                      className="btn btn-primary"
                      label="Odstranit instanci"
                      onClick={() => {
                          setActiveHost(host);
                          setActiveServer(server);
                          setActiveOrganization(organization);
                          history.push("/remove-organization");
                    }}
                  >delete</Button>
              )}
          />
          <TouchPageHeader_and_content_spaceBetween heightPx={50}/>
          <Info
              host={host}
              server={server}
              organization={organization}
              initialValues={{
                  notes: organization.notes,
                  billingContact: organization.billingContact
                      ? organization.billingContact.name
                      : null
              }}
          />

          <DebugElement text="/src/containers/Organization.js - balicky "/>

          <UsersAndPackages history={history} host={host} server={server} />

          <DebugElementEnd text="containers/Organization.js END"/>
      </div>
    );
  }

  return <div />;
};

export default compose(
  withRouter,
  connect(
    state => {
        return null;
    },
    {
      setActiveHost,
      setActiveServer,
      setActiveOrganization,
      setDialog,
    }
  )
)(Organization);



// WEBPACK FOOTER //
// ./src/pages/Organization.js